export default __webpack_public_path__ + "static/media/190629_190332_IMG_7746.33481f03.jpg";